import { render, staticRenderFns } from "./TestmodeRibbon.vue?vue&type=template&id=87b1c268"
import script from "./TestmodeRibbon.vue?vue&type=script&lang=js"
export * from "./TestmodeRibbon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports